import {Nut_Capabilities} from 'nutshell-core/settings-constants';

import {AiFeatureType} from 'nutshell-graphql-types';

export type FeatureGroup = {
    displayName: string;
    description: string;
    types: AiFeatureType[];
    settingName?: string;
};

export type FeatureGroupRow = {
    displayName: string;
    description: string;
    isEnabled: boolean;
    requiresUpgrade: boolean;
    totalUsage: number;
    settingName?: string;
    types: AiFeatureType[];
    canDisableGlobally: boolean;
};

export const OUTCOME_FEATURE_GROUPS: FeatureGroup[] = [
    {
        displayName: 'Lead researcher',
        description: 'Uncover more about your leads and get a briefing',
        types: [AiFeatureType.LEAD_RESEARCHER, AiFeatureType.LEAD_RESEARCH],
        settingName: Nut_Capabilities.AI_LEAD_RESEARCHER_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Email sequence writer, Sales objection coach, Sales pipeline designer',
        description: 'Optimize your process in Nutshell with these chat assistants',
        types: [
            AiFeatureType.EMAIL_SEQUENCE_WRITER,
            AiFeatureType.SALES_OBJECTION_COACH,
            AiFeatureType.SALES_PIPELINE_DESIGNER,
        ],
        settingName: Nut_Capabilities.AI_AGENTS_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Timeline summaries',
        description: 'Get a quick summary from your team’s interactions with any lead or contact',
        types: [AiFeatureType.TIMELINE_SUMMARIZER],
        settingName: Nut_Capabilities.AI_TIMELINE_SUMMARIES_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Video meeting notetaker',
        description:
            'Automatically log and summarize your meetings to Nutshell with Zoom, Google Meet, and Microsoft Teams',
        types: [
            AiFeatureType.ZOOM_NOTETAKER,
            AiFeatureType.GOOGLE_MEET_NOTETAKER,
            AiFeatureType.MICROSOFT_TEAMS_NOTETAKER,
        ],
        settingName: Nut_Capabilities.AI_VIDEO_MEETING_NOTETAKER_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Click-to-call notetaker',
        description: 'Dial, log, and summarize calls, directly from your browser',
        types: [AiFeatureType.CLICK_TO_CALL_NOTETAKER],
        settingName: Nut_Capabilities.AI_CLICK_TO_CALL_NOTETAKER_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Phone call notetaker',
        description:
            'Sync, log, and summarize every call from third party integrations such as Dialpad, CallRail, RingCentral, Aircall, or Kixie',
        types: [
            AiFeatureType.AIRCALL_NOTETAKER,
            AiFeatureType.CALLRAIL_NOTETAKER,
            AiFeatureType.KIXIE_NOTETAKER,
            AiFeatureType.DIALPAD_NOTETAKER,
            AiFeatureType.RINGCENTRAL_NOTETAKER,
        ],
        settingName: Nut_Capabilities.AI_PHONE_CALL_NOTETAKER_HIDE_SETTING_NAME,
    },
    {
        displayName: 'One-click email campaign builder',
        description: 'Create and send email campaigns with a single click using AI',
        types: [AiFeatureType.EMAIL_CAMPAIGN_BUILDER],
        settingName: Nut_Capabilities.AI_EMAIL_CAMPAIGN_BUILDER_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Speak to log (for mobile)',
        description:
            'Use Nutshell’s voice capture mode to schedule and log an activity by simply recording your voice',
        types: [AiFeatureType.SPEAK_TO_LOG],
        settingName: Nut_Capabilities.AI_SPEAK_TO_LOG_HIDE_SETTING_NAME,
    },
];

export const ASSIST_FEATURE_GROUPS: FeatureGroup[] = [
    {
        displayName: 'Email reply starter',
        description: 'Get suggestions on quick replies, directly from Nutshell',
        types: [AiFeatureType.EMAIL_REPLY_STARTER],
        settingName: Nut_Capabilities.AI_EMAIL_REPLIES_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Smart reports',
        description:
            'Tap into Nutshell’s powerful reports by asking what you’re looking for in plain English',
        types: [AiFeatureType.REPORT_GENERATOR],
        settingName: Nut_Capabilities.AI_SMART_REPORTS_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Lead recaps & next actions',
        description: 'Learn what happened and identify what’s next without opening a lead',
        types: [AiFeatureType.LEAD_SUMMARIZER],
        settingName: Nut_Capabilities.AI_LEAD_RECAPS_HIDE_SETTING_NAME,
    },
    {
        displayName: 'Note transcriber',
        description: 'Speak to Nutshell and get instant transcripts for notes and activity logs',
        types: [AiFeatureType.NOTE_TRANSCRIBER],
        settingName: Nut_Capabilities.AI_LIVE_NOTE_TRANSCRIPTION_HIDE_SETTING_NAME,
    },
    {
        displayName: 'AI follow-up tasks',
        description:
            'Each user turns this on or off in their own AI features settings. Tasks are created from summarized calls and meetings.',
        types: [AiFeatureType.AI_FOLLOW_UP_TASKS],
    },
    {
        displayName: 'Email digests',
        description:
            'Receive automated email summaries of your team’s CRM activity and key metrics',
        types: [AiFeatureType.USER_DIGEST, AiFeatureType.ADMIN_DIGEST],
    },
];
